module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon2.50ce7b78.svg";